export default __webpack_public_path__ + "static/media/note-close.0dc29e39.svg";